import script from "./AccountApply.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountApply.vue?vue&type=script&lang=ts&setup=true"

import "./AccountApply.vue?vue&type=style&index=0&id=1c69eba4&scoped=true&lang=less"
import "./AccountApply.vue?vue&type=style&index=1&id=1c69eba4&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c69eba4"]])

export default __exports__